import { Dictionary } from 'lodash';
import fromPairs from 'lodash/fromPairs';

export const craftToSlateMarks = {
  B: 'bold',
  Em: 'italic',
  U: 'underline',
  InlineCode: 'code',
};

export const slateToCraftMarks: Dictionary<any> = fromPairs(
  Object.entries(craftToSlateMarks).map((entry) => entry.reverse()),
);
